import React, { Component } from 'react';
import PasswordField from './PasswordField';
import { PropTypes } from 'prop-types';

class PasswordFieldContainer extends Component {

    constructor() {
        super();
        this.inputRef = React.createRef();
        this.state = {
            showPassword: false,
            isFocused: false
        }
    }

    handleClickShowPassword = () => {
        //The input must remain focused even if the showButton was clicked
        //TODO: showPasswordButton still triggers onBlur. Bug?
        this.setState({ showPassword: !this.state.showPassword });
    };

    handleFieldBlur = () => {
        this.setState({ isFocused: false }, () => this.props.handleFieldBlur());
    };

    render() {
        return (
            <PasswordField
                {...this.props}
                {...this.state}
                inputRef={this.inputRef}
                handleFieldBlur={this.handleFieldBlur}
                handleFieldFocus={() => this.setState({ isFocused: true })}
                handleClickShowPassword={this.handleClickShowPassword}
            />
        )
    }
  }

  PasswordFieldContainer.propTypes = {
    value: PropTypes.string,
    label: PropTypes.string,
    error: PropTypes.string,
    isFocused: PropTypes.bool,
    handleFieldBlur: PropTypes.func,
    handleFieldChange: PropTypes.func.isRequired
};

export default PasswordFieldContainer;